import React from 'react';
import { appPlaceholders } from '../data/site';
const HIGHLIGHT_SRC = 'https://cdn.magicpatterns.com/uploads/uL5FBMg8Ghv53D5sag9oF5/black-comet-labs-in-the-lab-highlight.png';
const SURFACES = ['bg-violet', 'bg-mist', 'bg-comet-green'];
function PhoneStudy() {
  return <div className="mx-auto w-[62%] max-w-[210px] rounded-[26px] border border-ink/25 bg-cream/70 p-3" aria-hidden="true" data-id="element-62" data-mp="v0021944a9ml">
      <div className="mx-auto mb-3 h-1 w-10 rounded-full bg-ink/20" data-id="element-63" data-mp="zy1l3u1jm8y2" />
      <div className="space-y-2.5" data-id="element-64" data-mp="14xxops6bvyd3">
        <div className="h-16 rounded-[6px] bg-ink/10" data-id="element-65" data-mp="14wwajeu0mvr5" />
        <div className="h-2 w-3/4 rounded-full bg-ink/15" data-id="element-66" data-mp="19p5y4o7nrjq9" />
        <div className="h-2 w-1/2 rounded-full bg-ink/10" data-id="element-67" data-mp="19ppfa2phi438" />
        <div className="grid grid-cols-2 gap-2.5 pt-1" data-id="element-68" data-mp="1dqr73yh2ndv6">
          <div className="h-12 rounded-[6px] bg-ink/10" data-id="element-69" data-mp="1dsc19mzh4usi" />
          <div className="h-12 rounded-[6px] bg-ink/10" data-id="element-70" data-mp="1iqx1hmeq7egy" />
        </div>
        <div className="h-2 w-2/3 rounded-full bg-ink/10" data-id="element-71" data-mp="1no5ktqbm1ojs" />
      </div>
    </div>;
}
export function InTheLab() {
  return <section id="lab" className="bg-cream py-20 md:py-28" data-id="element-72" data-mp="37ikde3w66wpr">
      <div className="mx-auto max-w-content px-5 md:px-8 lg:px-10" data-id="element-73" data-mp="32iy0jvk97ihh">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-74" data-mp="32kslh9vizalk">
          <div data-id="element-75" data-mp="2yhcq0gv6zgag">
            <h2 className="sr-only" data-id="element-76" data-mp="2yixlq9t8t59w">In the lab</h2>
            {/* Approved custom lettering, tightly cropped of its blank margins.
                The filter below knocks the artwork's light beige ground out to
                transparency by luminance, so only the violet fill, ink shadow
                and antialiased edges remain over the site cream. */}
            <svg width="0" height="0" aria-hidden="true" focusable="false" className="absolute h-0 w-0" data-id="element-77" data-mp="3henohz9025ou">
              <filter id="lab-lettering-knockout" colorInterpolationFilters="sRGB" data-id="element-78" data-mp="drx3vz6x4fr5">
                <feColorMatrix type="matrix" values="1 0 0 0 0
                          0 1 0 0 0
                          0 0 1 0 0
                          0.2126 0.7152 0.0722 0 0" data-id="element-79" data-mp="8zvkzuf8vqs5" />
                <feComponentTransfer data-id="element-80" data-mp="wup6gji58ai4">
                  <feFuncA type="table" tableValues="1 1 1 1 1 1 0.92 0.12 0" data-id="element-81" data-mp="j4bywi95yxtb" />
                </feComponentTransfer>
              </filter>
            </svg>
            <div className="w-[280px] max-w-full overflow-hidden sm:w-[380px] lg:w-[460px]" aria-hidden="true" data-id="element-82" data-mp="n4488x6dt7zq">
              <img src={HIGHLIGHT_SRC} alt="" className="-mb-[14%] -ml-[11%] -mt-[12%] w-[120%] max-w-none" style={{
              filter: 'url(#lab-lettering-knockout)'
            }} data-id="element-83" data-mp="e5im6s1pbau7" />
            </div>
          </div>
          <p className="max-w-sm text-[17px] leading-relaxed text-ink/70 lg:text-right" data-id="element-84" data-mp="48mjj2yhhixk">
            A few things we&rsquo;re building. Each with a world of its own.
          </p>
        </div>

        <ul className="mt-14 grid grid-cols-1 gap-1 sm:grid-cols-2 lg:grid-cols-3" data-id="element-85" data-mp="1yihw4214xnfr">
          {appPlaceholders.map((app, index) => app.screenshot ? <li key={app.slot} className="flex" data-id="element-86" data-mp="3f2kzp33wki7u">
                <article className="flex w-full min-w-0 flex-col bg-cream" data-id="element-87" data-mp="3ssem7erxqqee">
                  <img src={app.screenshot} alt={app.imageAlt} className="block aspect-square h-auto w-full object-contain" data-id="element-88" data-mp="3suizgnbq51rc" />
                  <div className="flex flex-1 flex-col border-t border-ink/15 px-6 pb-7 pt-6" data-id="element-89" data-mp="6nb144z81v4t">
                    <div className="flex flex-wrap items-center gap-2" data-id="element-90" data-mp="1opwzugumrb3">
                      <span className="rounded-[2px] border border-ink/25 px-2 py-1 text-[10px] font-medium uppercase tracking-[0.16em] text-ink/70" data-id="element-91" data-mp="flmoly4skct1">
                        {app.storeURL ? 'Available now' : 'Coming soon'}
                      </span>
                      {app.platform ? <span className="text-[12px] font-medium text-ink/65" data-id="element-92" data-mp="2cfzjk16sgxsp">
                          {app.platform}
                        </span> : null}
                    </div>
                    <h3 className="mt-5 font-display text-[26px] font-semibold leading-tight text-ink" data-id="element-93" data-mp="2it3udou7belt">
                      {app.name}
                    </h3>
                    {app.subheading ? <p className="mt-2 text-[16px] font-bold leading-snug text-ink" data-id="element-94" data-mp="2ss329575767r">
                        {app.subheading}
                      </p> : null}
                    <p className="mt-3 text-[15px] leading-relaxed text-ink/75" data-id="element-95" data-mp="204ytqq8uc9r8">
                      {app.description}
                    </p>
                  </div>
                </article>
              </li> : <li key={app.slot} className="flex" data-id="element-96" data-mp="29w393r2fhwml">
              <article className={`flex min-h-[420px] w-full flex-col lg:min-h-[480px] ${SURFACES[index % SURFACES.length]}`} data-id="element-97" data-mp="1cfe6vw9kgsco">
                <div className="flex items-start justify-end px-6 pt-6" data-id="element-98" data-mp="19ug9ajax1e8h">
                  <span className="rounded-[2px] border border-ink/25 px-2 py-1 text-[10px] font-medium uppercase tracking-[0.16em] text-ink/70" data-id="element-99" data-mp="14v3kvu4ebz3s">
                    {app.storeURL ? 'Available now' : 'Coming soon'}
                  </span>
                </div>

                <div className="flex flex-1 items-end justify-center px-6 pb-0 pt-8" data-id="element-100" data-mp="uwe6wcfmeyst">
                  <PhoneStudy data-id="element-101" data-mp="qw3y6s0g1ua9" />
                </div>

                <div className="border-t border-ink/15 px-6 py-5" data-id="element-102" data-mp="m4vpjy6xucy5">
                  <p className="font-display text-[22px] font-medium leading-tight text-ink" data-id="element-103" data-mp="m2ixgs7gum7d">
                    {app.name || app.label}
                  </p>
                  <p className="mt-1 text-[14px] leading-relaxed text-ink/70" data-id="element-104" data-mp="c7h93yl0lo5u">
                    {app.description || 'Details coming soon.'}
                  </p>
                </div>
              </article>
            </li>)}
        </ul>
      </div>
    </section>;
}